export default "__VITE_ASSET__BujNtuti__"